import React from "react";
import CompleteProfile from "../components/AuthPages/CompleteProfile";

function CompleteProfilePage() {
  return (
    <>
      <CompleteProfile />
    </>
  );
}

export default CompleteProfilePage;
